import { render, staticRenderFns } from "./Learn.vue?vue&type=template&id=4fcb9887&scoped=true&"
import script from "./Learn.vue?vue&type=script&lang=js&"
export * from "./Learn.vue?vue&type=script&lang=js&"
import style0 from "./Learn.vue?vue&type=style&index=0&id=4fcb9887&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcb9887",
  null
  
)

export default component.exports